import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { ConfigurationService } from '@common';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GraphqlService {
    protected config: ConfigurationService = inject(ConfigurationService);

    constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) {}

    public query(query: string, headers: HttpHeaders): Observable<any> {
        const url = this.config.getData()?.graphQL?.url;

        // Add generic headers :
        headers
            .set('X-Source', this.document.defaultView['ConfigInitial']?.oauth?.xSource)
            .set('Content-Type', 'application/json');

        return this.http.post(url, { query }, { headers });
    }
}
